import { momentWithHyphen } from '@/utils/datetimeUtil'

import attendanceApi from '../../../api/attendance/attendance'
import codeTableApi from '../../../api/hr/codeTable'
import systemApi from '../../../api/general/system'

const state = {
  attendancesWithLeaves: [],
  dateInWeek: null
}

// actions
const actions = {

  async getAttendanceAndLeave ({ commit }) {
    let leaves = []
    let attendances = []
    let startDate = momentWithHyphen(state.dateInWeek).day(0).format('YYYY-MM-DD') // Sunday
    let endDate = momentWithHyphen(state.dateInWeek).day(6).format('YYYY-MM-DD') // Saturday

    commit('setAttendancesWithLeaves', null)

    await attendanceApi.getAttendance(cb => {
      attendances = cb
    }, startDate, endDate)
    await attendanceApi.getAbsentInfo(cb => {
      leaves = cb
    }, startDate, endDate)
    await codeTableApi.getPubHolidaysByStartEndDay(cb => {
      let pubHodiay = cb
      let i = -1
      let tempRecords = null
      if (attendances) {
        tempRecords = attendances.map(record => {
          i++
          let leaveReasons = []
          if (leaves[i].absentInfoDetail && leaves[i].absentInfoDetail.length > 0) {
            leaves[i].absentInfoDetail.forEach(absentInfo => {
              let leaveObj = {
                code: absentInfo.absentCode,
                desc: this._vm.$chPtObjData('chinAbsentDesc', absentInfo),
                hasTime: !((absentInfo.startTime === null || absentInfo.startTime === absentInfo.endTime)),
                startTime: absentInfo.startTime,
                endTime: absentInfo.endTime
              }
              leaveReasons.push(leaveObj)
            })
          }
          return Object.assign(record, {
            holidayChinName: pubHodiay[i].holidayChinName,
            holidayPortName: pubHodiay[i].holidayPortName,
            leaves: leaveReasons
          })
        })
      }
      attendances = tempRecords
    }, startDate, endDate)

    commit('setAttendancesWithLeaves', attendances)
  },

  async getCurrentDate ({ commit }) {
    let currentDate = null
    await systemApi.getServerDateTime(cb => {
      currentDate = momentWithHyphen(cb)
    })
    commit('setDateInWeek', currentDate)
  },

  async getPreWeekRecords ({ commit, dispatch }) {
    commit('setPreWeekDate')
    await dispatch('getAttendanceAndLeave')
  },

  async getNextWeekRecords ({ commit, dispatch }) {
    commit('setNextWeekDate')
    await dispatch('getAttendanceAndLeave')
  }

}

const getters = {

}

const mutations = {

  setAttendancesWithLeaves (state, records) {
    state.attendancesWithLeaves = records
  },

  setDateInWeek (state, date) {
    state.dateInWeek = date
  },

  setPreWeekDate (state) {
    state.dateInWeek.subtract(7, 'days')
  },

  setNextWeekDate (state) {
    state.dateInWeek.add(7, 'days')
  }

}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
